import { Button, Card, Modal, Select, message } from "antd";
import PageTitle from "components/PageTitle";
import { ApiService } from "api/api.service";
import { useSearchParams } from "react-router-dom";
import { TbLoader } from "react-icons/tb";
import { queryClient } from "utils/queryClient";
import { useState } from "react";

const SelectPlanModal = ({
  isModalOpen,
  setIsModalOpen,
}: {
  isModalOpen: boolean;
  setIsModalOpen: React.Dispatch<React.SetStateAction<boolean>>;
}) => {
  const [searchParams, setSearchParams] = useSearchParams();
  const id = searchParams.get("id") || undefined;
  const affiliatePlansList = ApiService.affiliatePlans.useGetAllPaginated({
    page: 1,
    limit: 1000,
  });
  const assignPlan = ApiService.affiliatePlans.useAssignAffiliatePlan();
  const affiliatePlansData = affiliatePlansList.data?.data;
  const [selectedPlan, setSelectedPlan] = useState("");

  const onFinish = async () => {
    try {
      if (affiliatePlansData && id && selectedPlan) {
        const body = { user_id: id, plan_id: selectedPlan };
        assignPlan.mutate(body, {
          onSuccess: () => {
            message.success("Affiliate plan assigned successfully!");
            queryClient.invalidateQueries({ queryKey: ["user", "paginated"] });
            closeModal();
          },
        });
      }
    } catch (e) {
      console.log(e);
    }
  };

  const closeModal = () => {
    setSearchParams((prev) => {
      const params = new URLSearchParams(prev);
      params.delete("id");
      return params;
    });
    setIsModalOpen(false);
  };

  return (
    <Modal
      title="Assign Plan"
      open={isModalOpen}
      onCancel={closeModal}
      footer={[
        <Button key="cancel" onClick={closeModal}>
          Cancel
        </Button>,
        <Button
          key="update"
          disabled={assignPlan.isPending}
          type="primary"
          onClick={onFinish}
          htmlType="submit"
          icon={assignPlan.isPending && <TbLoader className="animate-spin" />}
        >
          {affiliatePlansData && assignPlan.isPending ? "Assigning plan..." : "Assign plan"}
        </Button>,
      ]}
    >
      <div className="flex m-6">
        <Select
          placeholder="Select Affiliate Plan"
          style={{ width: "100%" }}
          allowClear
          options={affiliatePlansData?.map((plan) => ({
            label: plan.name,
            value: plan._id,
          }))}
          onChange={(value) => setSelectedPlan(value)}
        />
      </div>
    </Modal>
  );
};

export default SelectPlanModal;
